import { render, staticRenderFns } from "./component-a590b44b.vue?vue&type=template&id=1f091a4b&scoped=true&"
import script from "./component-a590b44b.vue?vue&type=script&lang=js&"
export * from "./component-a590b44b.vue?vue&type=script&lang=js&"
import style0 from "./component-a590b44b.vue?vue&type=style&index=0&id=1f091a4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f091a4b",
  null
  
)

export default component.exports